<div fxLayout="column" fxLayoutAlign="center center">
    <img src="/assets/maintenance/maintenance.svg" alt="" />
    <h1>{{ 'COMMON.MAINTENANCE.TITLE.' + type | translate }}</h1>
    <p [innerHTML]="'COMMON.MAINTENANCE.DESCRIPTION.' + type | translate"></p>
    <a href="/" mat-raised-button color="primary">{{ 'COMMON.MAINTENANCE.BUTTON.TEXT' | translate }}</a>
</div>
